import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { isSearchInFavorites } from 'owa-favorites';
import { getUserConfiguration } from 'owa-session-store';

export default function getFavoriteSearchSuggestions(findText: string): FavoriteSuggestion[] {
    const searchHistory: string[] = getUserConfiguration().ViewStateConfiguration.SearchHistory;
    let searchSuggestions: string[] = [];
    for (const searchEntry of searchHistory) {
        if (searchEntry.toLowerCase().indexOf(findText.toLowerCase()) == 0) {
            searchSuggestions.push(searchEntry);
        }
    }

    // Filter out search queries that:
    // 1) are already favorites or
    // 2) are empty string searches
    // 3) contain KQL from queries (we want users to add favorite people instead)
    searchSuggestions = searchSuggestions.filter(
        searchQuery =>
            !isSearchInFavorites(searchQuery) &&
            searchQuery.trim() != '' &&
            searchQuery.toLowerCase().indexOf('from:') == -1
    );

    const maxSearchSuggestions = getMaxFavoriteSuggestionCounts().search;
    searchSuggestions.splice(maxSearchSuggestions);

    return searchSuggestions.map(seachEntry => {
        return {
            data: seachEntry,
            id: seachEntry,
            type: FavoriteSuggestionType.Search,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
}
